import { render, staticRenderFns } from "./UsuarioDetails.vue?vue&type=template&id=47bcde6e&"
import script from "./UsuarioDetails.vue?vue&type=script&lang=js&"
export * from "./UsuarioDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports